import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import MuseMethodPage from "@/pages/MuseMethodPage";
import PortfolioPage from "@/pages/PortfolioPage";
import AboutPage from "@/pages/AboutPage";
import BookACallPage from "@/pages/BookACallPage";
import TalentPage from "@/pages/TalentPage";
import VipContentDaysPage from "@/pages/VipContentDaysPage";
import GalleryPage from "@/pages/GalleryPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudyDetailPage";
import MiamiBeachPage from "@/pages/MiamiBeachPage";
import ArtWeekPage from "@/pages/ArtWeekPage";
import FindYourWavePage from "@/pages/FindYourWavePage";
import AudeSwimPage from "@/pages/AudeSwimPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><p className="text-muted-foreground text-sm tracking-widest uppercase">Loading...</p></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/method" element={<MuseMethodPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/portfolio/:slug" element={<GalleryPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/book-a-call" element={<BookACallPage />} />
              <Route path="/talent" element={<TalentPage />} />
              <Route path="/services/vip-content-days" element={<VipContentDaysPage />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/case-studies/city-of-miami-beach" element={<MiamiBeachPage />} />
              <Route path="/case-studies/art-week-miami-beach" element={<ArtWeekPage />} />
              <Route path="/case-studies/find-your-wave" element={<FindYourWavePage />} />
              <Route path="/case-studies/aude-swim" element={<AudeSwimPage />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
